import React from 'react'

export default function ExternalArrowIcon({ color = 'white', size = 24, strokeWidth = 1.5, ...props }) {
  return (
   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M8 8H16M16 8V16M16 8L8 16" stroke={color} strokeWidth={strokeWidth}/>
</svg>

  )
}
